module.exports = __webpack_public_path__ + "img/20210629_084550.d29d52ce.jpg";